import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IHierarchyKeyObjectives } from '../../keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/models/hierarchyKeyObjectives'

interface ITransformKeyObjectivesDataToHierarchyFormat {
  programType?: ProgramTypes
  keyObjectivesFilter?: string
  keyObjectivesSettingsList: IKeyObjective[]
  isDataInsightTab?: boolean
}

export const transformKeyObjectivesDataToHierarchyFormat = ({
  programType,
  keyObjectivesFilter,
  keyObjectivesSettingsList,
  isDataInsightTab,
}: ITransformKeyObjectivesDataToHierarchyFormat): IHierarchyKeyObjectives[] => {
  return keyObjectivesSettingsList
    .filter((ko) => {
      if (isDataInsightTab) {
        return ko.dataInsight
      }

      return ko
    })
    .filter(
      (el) =>
        (!el.offerings || (programType && el.offerings.indexOf(programType) >= 0)) &&
        (!keyObjectivesFilter || el.key === keyObjectivesFilter)
    )
    .map((el) => {
      const hasChildren = keyObjectivesSettingsList
        .filter((child) => child.parent === el.key)
        .some((child) => !child.offerings || !programType || child.offerings.includes(programType))

      const breadcrumbParts: string[] = []
      let current: IKeyObjective | undefined = el
      while (current) {
        breadcrumbParts.unshift(current.key)
        const parentKey: string | null | undefined = current.parent
        current = parentKey
          ? keyObjectivesSettingsList.find((item) => item.key === parentKey)
          : undefined
      }

      return {
        ...el,
        HasChildren: hasChildren,
        Breadcrumb: breadcrumbParts.join(' > '),
      }
    })
}
